(function () {
    'use strict';

    angular.module("imApp").factory("propertyClassLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 3461,
                    parameters: parms || {}
                });
            },
            saveLanguages: function (list) {
                return $ihttp.post({
                    method: 3462,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
